import { render, staticRenderFns } from "./DealPutDownModal.vue?vue&type=template&id=0e5cd87a&"
import script from "./DealPutDownModal.vue?vue&type=script&lang=ts&"
export * from "./DealPutDownModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports